import React from 'react'
import PropTypes from 'prop-types'
import styles from './MobileFilterButton.module.css'
import { MobileFilterContext } from '../../components'

const MobileFilterButton = ({ filterKey, children }) => {
  return (
    <MobileFilterContext.Consumer>
      {({ setActivePanel }) => (
        <button className={`${styles.button} py-2 px-4 outline-none`}>
          <div
            className="text-gray-999 text-xs font-bold flex items-center"
            onClick={() => setActivePanel(filterKey)}
          >
            { children }
          </div>
        </button>
      )}
    </MobileFilterContext.Consumer>
  )
}

MobileFilterButton.propTypes = {
  filterKey: PropTypes.string.isRequired,
}

export { MobileFilterButton }
